// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"p5-z"};